import isNil from 'ramda/src/isNil';
import isEmpty from 'ramda/src/isEmpty';
import either from 'ramda/src/either';

export default either( isNil, isEmpty );
